import { BaselineAudit_Entity } from '../baseline-audit';
import { ArrayTypeSchema, EnumBaselineProp, SchemaValue } from '../schema';
import { Baseline } from '../../../../stores/client/sway/baseline/model';

export interface SafeAttachmentPolicy_SchemaData {
    Identity: SchemaValue<string>;
    Priority: SchemaValue<number, 'number'>;
    Enable: SchemaValue<boolean, 'boolean'>;
    Action: SchemaValue<string>;
    QuarantineTag?: SchemaValue<string>;
    Redirect?: SchemaValue<boolean, 'boolean'>;
    RedirectAddress?: SchemaValue<string>;
    SentTo?: EnumBaselineProp | { type: 'null' };
    SentToMemberOf?: EnumBaselineProp | { type: 'null' };
    RecipientDomainIs?: EnumBaselineProp | { type: 'null' };
    ExceptIfSentTo?: EnumBaselineProp | { type: 'null' };
    ExceptIfSentToMemberOf?: EnumBaselineProp | { type: 'null' };
    ExceptIfRecipientDomainIs?: EnumBaselineProp | { type: 'null' };
}

export type SafeAttachmentPolicy_Schema = ArrayTypeSchema<SafeAttachmentPolicy_SchemaData>;
export type SafeAttachmentPolicy_Baseline = Baseline<SafeAttachmentPolicy_SchemaData>;
export type SafeAttachmentPolicy_Deviation = BaselineAudit_Entity<SafeAttachmentPolicy_Schema>;

interface SafeAttachmentPolicy_Form {
    Priority: number;
    Enable: boolean;
    Action: string;
    QuarantineTag: string;
    Redirect: boolean;
    RedirectAddress: string;
    SentTo: string[];
    SentToMemberOf: string[];
    RecipientDomainIs: string[];
    ExceptIfSentTo: string[];
    ExceptIfSentToMemberOf: string[];
    ExceptIfRecipientDomainIs: string[];
    Identity: string;
}

export function buildSafeAttachmentPolicySchema(form: SafeAttachmentPolicy_Form): SafeAttachmentPolicy_Schema {
    const schema: SafeAttachmentPolicy_Schema = {
        type: 'array',
        contains: {
            type: 'object',
            properties: {
                Identity: { type: 'string', const: form.Identity },
                Priority: { type: 'number', const: form.Priority },
                Enable: { type: 'boolean', const: form.Enable },
                Action: { type: 'string', const: form.Action },
                QuarantineTag: { type: 'string', const: form.QuarantineTag },
                Redirect: { type: 'boolean', const: form.Redirect },

                SentTo: getEnumItem(form.SentTo),
                SentToMemberOf: getEnumItem(form.SentToMemberOf),
                RecipientDomainIs: getEnumItem(form.RecipientDomainIs),
                ExceptIfSentTo: getEnumItem(form.ExceptIfSentTo),
                ExceptIfSentToMemberOf: getEnumItem(form.ExceptIfSentToMemberOf),
                ExceptIfRecipientDomainIs: getEnumItem(form.ExceptIfRecipientDomainIs),
            },
            required: ['Identity', 'Name', 'Priority', 'Enable', 'Action'],
        },
    };

    if (form.Redirect) {
        schema.contains.properties.RedirectAddress = { type: 'string', const: form.RedirectAddress };
    } else {
        delete schema.contains.properties.RedirectAddress;
    }

    return schema;
}

function getEnumItem(items: string[]): EnumBaselineProp | { type: 'null' } {
    if (items?.length > 0) {
        return {
            type: 'array',
            items: { enum: [...items], type: 'string' },
            minItems: items.length,
            maxItems: items.length,
            uniqueItems: true,
        };
    }
    return { type: 'null' };
}
